import { useAccount, useChains } from 'wagmi'

/**
 * Checks if the current chain is supported by the app.
 * @returns 'offline' if the user is not connected, 'unsupported' if the chain is not supported, and 'supported' if the chain is supported.
 */
export function useAccountChainStatus(): 'supported' | 'unsupported' | 'offline' {
	const { chainId, status } = useAccount()
	const chains = useChains()

	return ['disconnected', 'connecting'].includes(status)
		? 'offline'
		: chains.some(chain => chain.id === chainId)
			? 'supported'
			: 'unsupported'
}
